module.exports = __webpack_public_path__ + "static/media/right.17472cca.svg";